/* V108 : formulaires d'inscription branchés sur Klaviyo (compte Tpq8Xr, double opt-in).
   Pied de page → liste « Liste d'adresses e-mail » (WZsq57) ; accueil, sticks → « Lancement sticks vitamine C liposomale » (SBze2h).
   Écoute en phase de capture : remplace l'ancien gestionnaire « maquette » de bx-v10.js sans modifier ce fichier.
   V108 : retrait du champ « subscriptions », refusé par l'API client (erreur 400).
   V118-V119 : secours si Klaviyo est injoignable (bloqueur de pub) → formulaire client Shopify caché #bx-news-secours (bx-footer, captcha lié par Shopify.captcha.protect), tags newsletter ;
   le profil remonte ensuite dans Klaviyo par la synchro Shopify. */
(function(){
  const COMPANY='Tpq8Xr';
  const target=f=>f.classList.contains('t2-form')
    ?{list:'SBze2h',tags:'newsletter,lancement-sticks',source:'Accueil - lancement sticks',ok:'Merci ! Confirme ton inscription dans l’e-mail qu’on vient de t’envoyer : tu seras prévenu au lancement des sticks.'}
    :{list:'WZsq57',tags:'newsletter',source:'Pied de page - newsletter',ok:'Merci ! Confirme ton inscription dans l’e-mail qu’on vient de t’envoyer.'};
  const fallback=(f,t,email)=>{
    const g=document.getElementById('bx-news-secours');
    if(!g){if(window.bxToast)bxToast('L’inscription n’a pas abouti. Réessaie dans un instant.');
      const b=f.querySelector('button');if(b)b.disabled=false;return;}
    g.querySelector('[name="contact[email]"]').value=email;
    g.querySelector('[name="contact[tags]"]').value=t.tags;
    const C=window.Shopify&&Shopify.captcha;
    if(C&&!g.dataset.hcaptchaBound)C.protect(g,()=>g.requestSubmit());else g.requestSubmit();
  };
  if(/[?&]customer_posted=true/.test(location.search))
    setTimeout(()=>window.bxToast&&bxToast('Merci, ton inscription est bien enregistrée.'),400);
  const note='En t’inscrivant, tu acceptes de recevoir nos e-mails. Désinscription en un clic. <a href="/policies/privacy-policy">Confidentialité</a>';

  document.querySelectorAll('form[data-teaser]').forEach(f=>{
    const p=document.createElement('p');p.className='bx-consent';p.innerHTML=note;
    p.style.cssText='font-size:12px;line-height:1.4;opacity:.75;margin:8px 0 0';
    f.after(p);
  });

  document.addEventListener('submit',async e=>{
    const f=e.target.closest&&e.target.closest('form[data-teaser]');if(!f)return;
    e.preventDefault();e.stopPropagation();
    const input=f.querySelector('input[type="email"]'),btn=f.querySelector('button'),email=(input&&input.value||'').trim();
    if(!email||!input.checkValidity())return;
    const t=target(f);if(btn)btn.disabled=true;
    try{
      const r=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+COMPANY,{method:'POST',
        headers:{'Content-Type':'application/vnd.api+json',revision:'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:t.source,
          profile:{data:{type:'profile',attributes:{email}}}},
          relationships:{list:{data:{type:'list',id:t.list}}}}})});
      if(!r.ok)throw new Error(r.status);
      const ok=document.createElement('p');ok.className='teaser-ok';ok.textContent=t.ok;
      f.replaceWith(ok);
    }catch(err){
      fallback(f,t,email);
    }
  },true);
})();
